import Error500 from '../Reusable_Components/Error Components/Error500';

export const API_DOMAIN = 'http://127.0.0.1:8080/'; // backend domain

export const MAIN_APP_FRONTEND_DOMAIN = 'https://37f2e40b.central-frontend.pages.dev/';

const token = localStorage.getItem('finance_accounting_token');   
export const headers = token ? { 
    'Content-Type': 'application/json', 
    'Authorization': `Token ${token}`
} : {
    'Content-Type': 'application/json',
}; 

export const API_ROUTES = {
  //Auth
  verifyHandshake: 'security/audit/verify-handshake/',


  // Cash Flow
  account: 'cash/flow/accounts/',
  transaction: 'cash/flow/transactions/',
  expense: 'cash/flow/expenses/',
  income: 'cash/flow/incomes/',
  cashFlowStatement: 'cash/flow/cash-flow-statements/',
  asset: 'cash/flow/assets/',
  financial_forecast: 'cash/flow/financial-forecasts/',
  budget: 'cash/flow/budgets/',

  // Invoicing and Billing 
  customer: 'invoicing/billing/customers/',
  invoice: 'invoicing/billing/invoices/',
  invoice_item: 'invoicing/billing/invoice-items/',
  payment: 'invoicing/billing/payments/',
  billing_cycle: 'invoicing/billing/billing-cycles/',
  credit_note: 'invoicing/billing/credit-notes/',
  waiver: 'invoicing/billing/waivers/',

  // Taxation and Compliance
  tax_type: 'taxation/compliance/tax-types/',
  tax_slab: 'taxation/compliance/tax-slabs/',
  tax_filing: 'taxation/compliance/tax-filings/',

  // General Ledger
  generalCurrency: 'general/ledger/currencies/',
  financial_period: 'general/ledger/financial-periods/',
  journal_entry: 'general/ledger/journal-entries/',
  chart_of_account: 'general/ledger/chart-of-accounts/',

  // Security and Audit
  audit_log: 'security/audit/audit-log/',
  login_activity: 'security/audit/login-activity/'
  // Add other routes as needed
};


export const handleError = (error) => {
  console.error('Error caught in handleError:', error);

  if (error.response) {
    const status = error.response.status;

    switch (status) {
      case 400:
        console.warn('Bad Request:', error.response.data);
        window.location.href = '/400';
        break;

      case 401:
        console.warn('Unauthorized: Redirecting to login');
        window.location.href = '/401';
        break;

      case 403:
        console.warn('Forbidden: Access denied');
        window.location.href = '/403';
        break;

      case 404:
        console.warn('Not Found');
        window.location.href = '/404';
        break;

      case 500:
      default:
        console.error('Server error');
        <Error500 message={error.message} />
        // window.location.href = '/500';
        
        break;
    }
  } else if (error.request) {
    // The request was made but no response was received
    console.error('Network error or no response from server.');
    <Error500 message='Network error or no response from server.' />
  } else {
    // Something else triggered the error
    console.error('Unexpected error:', error.message);
    <Error500 message={error.message} />
  }
};

export const getApiEndpoint = (route) => `${API_DOMAIN}${API_ROUTES[route]}`;
